import { RootState } from "../index";
import { createDraftSafeSelector } from "@reduxjs/toolkit";

const selectAppReducer = (state: RootState) => state;

export const selectProducts = createDraftSafeSelector(
  selectAppReducer,
  (state) => state.dProducts,
);

export const selectProductsFilters = createDraftSafeSelector(
  selectProducts,
  (state) => state.filters,
);

export const selectProductsPagination = createDraftSafeSelector(
  selectProducts,
  (state) => state.pagination,
);

export const selectProductsDetailItem = createDraftSafeSelector(
  selectProducts,
  (state) => state.detailItem,
);
